import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { QuoteCartProvider } from "./context/QuoteCartContext";
import { SiteProvider } from "./context/SiteContext";
import { Toaster } from "./components/ui/toaster";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/Header";
import Footer from "./components/Footer";
import QuoteCart from "./components/QuoteCart";
import ChatWidget from "./components/ChatWidget";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Projects from "./pages/Projects";
import Partners from "./pages/Partners";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/admin/Dashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div className="min-h-[70vh] grid place-items-center bg-[#070a12] text-center px-6" data-testid="not-found-page">
      <div>
        <div className="font-display font-extrabold text-7xl fire-text">404</div>
        <h1 className="font-heading font-bold text-2xl text-white mt-4">Page not found</h1>
        <p className="text-gray-400 mt-2">The page you are looking for doesn’t exist or has moved.</p>
        <a href="/" className="inline-block mt-6 px-6 py-3 rounded-xl bg-gradient-to-r from-primary to-accent text-white font-heading font-bold">Back to Home</a>
      </div>
    </div>
  );
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <QuoteCart />
      <ChatWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <QuoteCartProvider>
          <SiteProvider>
          <BrowserRouter>
            <ScrollToTop />
            <ErrorBoundary>
            <Routes>
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/products" element={<PublicLayout><Products /></PublicLayout>} />
              <Route path="/product/:id" element={<PublicLayout><ProductDetail /></PublicLayout>} />
              <Route path="/projects" element={<PublicLayout><Projects /></PublicLayout>} />
              <Route path="/partners" element={<PublicLayout><Partners /></PublicLayout>} />
              <Route path="/careers" element={<PublicLayout><Career /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
            </Routes>
            </ErrorBoundary>
            <Toaster />
          </BrowserRouter>
          </SiteProvider>
        </QuoteCartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
